import { render, staticRenderFns } from "./UploadXmlPdfOrder.vue?vue&type=template&id=f9321706&scoped=true&"
import script from "./UploadXmlPdfOrder.vue?vue&type=script&lang=js&"
export * from "./UploadXmlPdfOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9321706",
  null
  
)

export default component.exports